import React, { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";

const MENU_URL = "https://soho69tfs.com/menu";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/zk7tuj6l_IMG_1952.jpg";
const SIZES = {
  a5: { label: "A5 Table Card", w: 148, h: 210, base: "3.6mm" },
  a4: { label: "A4 Wall Poster", w: 210, h: 297, base: "5.1mm" },
};

function PosterCard({ id }) {
  const s = SIZES[id];
  return (
    <div
      data-testid={`qr-poster-${id}`}
      className="qr-poster relative bg-black text-white overflow-hidden flex flex-col items-center justify-between text-center"
      style={{
        width: `${s.w}mm`, height: `${s.h}mm`, fontSize: s.base, padding: "2.2em 1.8em",
        backgroundImage: "radial-gradient(70% 45% at 50% 0%, rgba(255,27,141,0.35), transparent 70%), radial-gradient(60% 40% at 50% 100%, rgba(166,85,242,0.25), transparent 70%)",
      }}
    >
      <div className="absolute pointer-events-none" style={{ inset: "0.9em", border: "0.18em solid #FF1B8D", borderRadius: "1.2em", boxShadow: "0 0 1.2em rgba(255,27,141,0.8), inset 0 0 1.2em rgba(255,27,141,0.5)" }} />
      <div className="relative flex flex-col items-center">
        <img src={LOGO_URL} alt="Soho69" style={{ width: "4.6em", height: "4.6em", borderRadius: "50%", border: "0.1em solid #FF1B8D", boxShadow: "0 0 1.4em rgba(255,27,141,0.7)" }} />
        <div className="font-heading uppercase mt-[0.5em]" style={{ fontSize: "3.4em", lineHeight: 0.95, textShadow: "0 0 0.3em rgba(255,27,141,0.8)" }}>
          SOHO <span className="text-neon">69</span>
        </div>
        <div className="uppercase text-white/60" style={{ fontSize: "0.8em", letterSpacing: "0.5em", marginTop: "0.4em" }}>Tenerife · Lounge Club</div>
      </div>
      <div className="relative flex flex-col items-center">
        <div className="font-heading uppercase text-neon" style={{ fontSize: "2.2em", lineHeight: 1, textShadow: "0 0 0.35em rgba(255,27,141,0.9)" }}>Scan for the menu</div>
        <div className="uppercase text-white/70" style={{ fontSize: "0.9em", letterSpacing: "0.3em", marginTop: "0.5em" }}>Escanea para ver la carta</div>
        <div style={{ marginTop: "1.2em", padding: "0.9em", background: "#fff", borderRadius: "1em", boxShadow: "0 0 1.6em rgba(255,27,141,0.85), 0 0 3.2em rgba(255,27,141,0.45)" }}>
          <QRCodeSVG value={MENU_URL} level="H" fgColor="#000000" bgColor="#ffffff" style={{ width: "12em", height: "12em", display: "block" }} data-testid={`qr-code-${id}`} />
        </div>
        <div className="uppercase text-white" style={{ fontSize: "0.95em", letterSpacing: "0.32em", marginTop: "1.1em" }}>Shots · Cocktails · Drinks</div>
      </div>
      <div className="relative">
        <div className="font-bold text-neon" style={{ fontSize: "1em", letterSpacing: "0.12em" }}>soho69tfs.com/menu</div>
        <div className="uppercase text-white/50" style={{ fontSize: "0.65em", letterSpacing: "0.3em", marginTop: "0.4em" }}>VIP tables & bottle service available</div>
      </div>
    </div>
  );
}

export default function MenuQrPoster() {
  const [printing, setPrinting] = useState(null);

  useEffect(() => {
    document.title = "Soho69 · Menu QR Poster";
    if (!printing) return;
    const done = () => setPrinting(null);
    window.addEventListener("afterprint", done);
    const t = setTimeout(() => window.print(), 50);
    return () => { clearTimeout(t); window.removeEventListener("afterprint", done); };
  }, [printing]);

  const size = printing ? SIZES[printing] : null;
  return (
    <div data-testid="qr-poster-page" className="min-h-screen bg-neutral-950 text-white py-10 px-4 print:p-0 print:bg-black">
      {size && (
        <style>{`@page { size: ${size.w}mm ${size.h}mm; margin: 0; }
          @media print { body { background:#000 !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .no-print { display:none !important; } .qr-page-wrap { padding:0 !important; gap:0 !important; }
          .qr-poster-slot:not([data-slot="${printing}"]) { display:none !important; } .qr-poster-slot { overflow:visible !important; } }`}</style>
      )}
      <div className="no-print max-w-3xl mx-auto mb-8">
        <h1 className="font-heading text-4xl sm:text-5xl uppercase">Menu <span className="text-neon">QR</span> Posters</h1>
        <p className="mt-2 text-sm text-white/60">Print and place on tables or at the bar. The QR opens {MENU_URL} with the Shots and Drink menus.</p>
      </div>
      <div className="qr-page-wrap flex flex-wrap justify-center items-start gap-10">
        {Object.entries(SIZES).map(([id, s]) => (
          <div key={id} data-slot={id} className="qr-poster-slot flex flex-col items-center gap-4 max-w-full overflow-x-auto">
            <button
              type="button"
              data-testid={`print-${id}-btn`}
              onClick={() => setPrinting(id)}
              className="no-print inline-flex items-center gap-2 px-6 py-3 rounded-full font-bold uppercase tracking-[0.2em] text-sm text-black transition-transform duration-200 hover:scale-105"
              style={{ background: "linear-gradient(135deg,#FF1B8D,#FF6BC6)", boxShadow: "0 0 24px rgba(255,27,141,0.6)" }}
            >
              <Printer size={16} /> Print {s.label}
            </button>
            <PosterCard id={id} />
          </div>
        ))}
      </div>
    </div>
  );
}
